/** @type {Record<string, import("./types.js").LandingPageContent>} */
export const landingContentNl = {
  "zaagplan-maken": {
    "title": "Zaagplan maken | Gratis online | Plaatplan",
    "description": "Maak gratis een zaagplan voor plaatmateriaal. Voer je panelen in, zie de zaagindeling en exporteer een werkplan met zaaglijst voor de bouwmarkt of zaagservice.",
    "h1": "Zaagplan maken voor plaatmateriaal",
    "lead": "Een zaagplan (of zaagschema) toont hoe je onderdelen uit standaardplaten zaagt. Met Plaatplan vul je maten en aantallen in, zie je direct hoeveel platen je nodig hebt en neem je een printbaar werkplan mee. Gratis, zonder account.",
    "ctaLabel": "Start met plannen",
    "sections": [
      {
        "h2": "Wat is een zaagplan?",
        "paragraphs": [
          "Een zaagplan is een overzicht van hoe rechthoekige onderdelen op één of meer platen liggen. Je ziet welke sneden nodig zijn, hoeveel afval overblijft en welke maten je aan de zaagservice doorgeeft.",
          "Plaatplan is gemaakt voor doe-het-zelvers die meerdere projecten tegelijk plannen, bijvoorbeeld een kast én een bureau uit dezelfde MDF-plaat."
        ]
      },
      {
        "h2": "Zaagplan, zaaglijst en werkplan",
        "paragraphs": [
          "Het zaagplan is de visuele indeling: hoe onderdelen op de plaat liggen. De zaaglijst is de tabel met zaagmaten en aantallen die de zaagbalie nodig heeft. Het werkplan is het complete pakket dat je print of meeneemt: zaaglijst, instructies en tekening per plaat."
        ]
      },
      {
        "h2": "Zaagplan of zaagschema?",
        "paragraphs": [
          "In de praktijk betekenen zaagplan en zaagschema hetzelfde: de indeling van onderdelen op een plaat. Bouwmarkten en zaagservices gebruiken beide termen."
        ]
      }
    ]
  },
  "zaagplan-mdf": {
    "title": "Zaagplan MDF maken | Gratis indeling 2440×1220 | Plaatplan",
    "description": "Gratis zaagplan voor MDF-platen. Bereken hoeveel platen van 2440×1220 mm je nodig hebt, met kerf en zaagindeling. Exporteer een zaaglijst als PDF of CSV voor de bouwmarkt.",
    "h1": "Zaagplan maken voor MDF",
    "lead": "MDF is populair voor kasten, nissen en interieurprojecten. Plaatplan helpt je panelen efficiënt in te delen op standaard MDF-platen (meestal 2440 × 1220 mm, 18 mm dik) en berekent hoeveel platen je moet bestellen.",
    "ctaLabel": "MDF-zaagplan starten",
    "sections": [
      {
        "h2": "Hoeveel MDF-platen heb ik nodig?",
        "paragraphs": [
          "Voer al je onderdelen in met lengte, breedte en aantal. Plaatplan groepeert panelen per dikte en deelt ze in over zo min mogelijk platen. Je ziet meteen of alles past en hoeveel standaardplaten je moet kopen.",
          "Tip: voeg restmateriaal toe dat je nog hebt liggen. De planner gebruikt kleinere stukken vóór nieuwe platen."
        ]
      },
      {
        "h2": "MDF laten zagen bij de bouwmarkt",
        "paragraphs": [
          "Exporteer je werkplan als PDF of print. Het bevat maten, aantallen en kantafwerking in een vendor-neutraal formaat dat je bij Hornbach, Gamma, Karwei of een andere zaagservice kunt inleveren."
        ]
      },
      {
        "h2": "Kerf en nerfrichting bij MDF",
        "paragraphs": [
          "Bij MDF mag je panelen meestal 90° draaien voor een efficiëntere indeling. Stel de zaagbreedte (kerf) in op 2,2 mm of de waarde van je zaagblad. Plaatplan houdt daar rekening mee in de layout."
        ]
      }
    ]
  },
  "zaagplan-multiplex": {
    "title": "Zaagplan multiplex maken | Nerfrichting & indeling | Plaatplan",
    "description": "Maak een zaagplan voor multiplex en berkenmultiplex. Houd nerfrichting vast, bereken platen en exporteer een werkplan met zaaglijst voor zelf zagen of laten zagen.",
    "h1": "Zaagplan maken voor multiplex",
    "lead": "Bij zichtbare multiplex telt de nerfrichting. Plaatplan laat je panelen vastzetten op nerfrichting, berekent de indeling op standaardplaten en toont een visueel zaagschema per plaat.",
    "ctaLabel": "Multiplex-zaagplan starten",
    "sections": [
      {
        "h2": "Nerfrichting bij multiplex",
        "paragraphs": [
          "Zet nerfrichting vast als de houtnerf zichtbaar is in je project. Panelen draaien dan niet ongewenst. Bij onzichtbare constructiepanelen kun je rotatie toestaan voor minder afval."
        ]
      },
      {
        "h2": "Multiplex zaagindeling",
        "paragraphs": [
          "Voer per deelproject je panelen in: zijkanten, planken, achterwanden. Onderdelen met dezelfde dikte kunnen op één plaat, kleurgecodeerd per project. Zo zie je of je één of twee platen multiplex nodig hebt."
        ]
      },
      {
        "h2": "Van zaagplan naar werkplaats",
        "paragraphs": [
          "Print het werkplan of exporteer een CSV. Je hebt een zaaglijst met maten, zaagvolgorde en optioneel strokenmodus voor de zaagservice."
        ]
      }
    ]
  },
  "zaagplan-spaanplaat": {
    "title": "Zaagplan spaanplaat maken | Gratis online | Plaatplan",
    "description": "Gratis zaagplan voor spaanplaat. Panelen indelen op standaardformaten, platen tellen en een werkplan met zaaglijst exporteren voor bouwmarkt of eigen zaagtafel.",
    "h1": "Zaagplan maken voor spaanplaat",
    "lead": "Spaanplaat is een betaalbare keuze voor kasten, achterwanden en constructiepanelen. Plaatplan berekent je zaagindeling op standaardformaten en helpt verspilling te beperken.",
    "ctaLabel": "Spaanplaat-plan starten",
    "sections": [
      {
        "h2": "Spaanplaat indelen",
        "paragraphs": [
          "Kies je plaatformaat (bijv. 2440 × 1220 mm) en dikte. Voer onderdelen in per project. De planner optimaliseert de indeling en toont reststukken.",
          "Voor panelen met decorlaag (wit, eiken, betonlook) kun je ook onze gids voor meubelpaneel gebruiken."
        ]
      },
      {
        "h2": "Zaagschema voor de bouwmarkt",
        "paragraphs": [
          "Een duidelijk zaagschema bespaart tijd aan de zaagbalie. Met Plaatplan heb je maten, aantallen en een visuele indeling per plaat, klaar om af te drukken."
        ]
      }
    ]
  },
  "zaagplan-meubelpaneel": {
    "title": "Zaagplan meubelpaneel maken | Melamine & decor | Plaatplan",
    "description": "Gratis zaagplan voor meubelpaneel en melamine. Panelen met decor indelen, platen tellen en een werkplan met zaaglijst meenemen naar de bouwmarkt of zaagservice.",
    "h1": "Zaagplan maken voor meubelpaneel",
    "lead": "Meubelpaneel (vaak met melamine of HPL-deklaag) is de standaard voor kasten en interieurprojecten. Plaatplan helpt je panelen in te delen op standaardplaten, houdt rekening met kerf en levert een printbaar werkplan. Gratis, zonder account.",
    "ctaLabel": "Meubelpaneel-plan starten",
    "sections": [
      {
        "h2": "Meubelpaneel, melamine en decor",
        "paragraphs": [
          "In de bouwmarkt heet het meubelpaneel, melamineplaat of paneel met decorlaag: wit, eiken, betonlook of een andere afwerking. Voor de indeling telt vooral het formaat en de dikte; de planner werkt met jouw maten en aantallen.",
          "Heeft je decor een richting (nerf of patroon)? Zet nerfrichting vast zodat panelen niet ongewenst draaien."
        ]
      },
      {
        "h2": "Hoeveel platen heb ik nodig?",
        "paragraphs": [
          "Voer zijkanten, planken, deuren en achterwanden in per deelproject. Panelen met dezelfde dikte kunnen op één plaat, kleurgecodeerd per project. Zo zie je direct hoeveel standaardplaten je moet bestellen."
        ]
      },
      {
        "h2": "Meenemen naar de zaagservice",
        "paragraphs": [
          "Exporteer je werkplan als PDF of print. Het bevat maten, aantallen en kantafwerking in een vendor-neutraal formaat, bruikbaar bij Hornbach, Gamma, Karwei en andere zaagservices."
        ]
      }
    ]
  },
  "bouwmarkt-zaagplan": {
    "title": "Platen laten zagen bouwmarkt | Zaagplan meenemen | Plaatplan",
    "description": "Maak gratis een zaagplan voor de bouwmarkt of zaagservice. Platen laten zagen bij Hornbach, Gamma of Karwei? Neem een werkplan met zaaglijst, maten en indeling mee.",
    "h1": "Platen laten zagen bij de bouwmarkt",
    "lead": "Bij Hornbach, Gamma, Karwei en andere bouwmarkten kun je platen laten zagen, mits je duidelijke maten en aantallen meegeeft. Plaatplan maakt dat zaagplan voor je: indeling op de plaat, aantal platen en een printbaar werkplan.",
    "ctaLabel": "Zaagplan maken",
    "sections": [
      {
        "h2": "Wat neem je mee naar de zaagbalie?",
        "paragraphs": [
          "Een goed zaagplan bevat per onderdeel lengte, breedte en aantal, plus eventueel kantafwerking. Plaatplan exporteert een vendor-neutraal werkplan met zaaglijst: geen merk-specifiek formulier, maar wel alles wat de zaagmedewerker nodig heeft.",
          "Print het werkplan of open het op je telefoon. Controleer vooraf of je zaagbreedte (kerf) klopt met die van de bouwmarkt."
        ]
      },
      {
        "h2": "Hornbach, Gamma, Karwei: werkt het overal?",
        "paragraphs": [
          "Plaatplan is niet gekoppeld aan één bouwmarkt. De export is generiek: maten, aantallen, zaagindeling en optioneel een visueel schema per plaat. Zo kun je hetzelfde plan bij verschillende zaagservices gebruiken.",
          "Let op: elke zaagservice heeft eigen regels voor minimale afmetingen, kanten frezen en maximale sneden per plaat. Check dat altijd lokaal."
        ]
      },
      {
        "h2": "Van indeling naar inkoop",
        "paragraphs": [
          "Plaatplan telt hoeveel standaardplaten je nodig hebt en toont welke reststukken overblijven. Zo bestel je niet te veel materiaal en weet je precies wat je aan de zaagbalie afgeeft."
        ]
      }
    ]
  },
  "zaagindeling": {
    "title": "Zaagindeling berekenen voor platen | Plaatplan",
    "description": "Bereken gratis de zaagindeling voor plaatmateriaal. Zie hoe panelen op de plaat liggen, met kerf, restmateriaal en export naar werkplan met zaaglijst.",
    "h1": "Zaagindeling berekenen voor plaatmateriaal",
    "lead": "Zaagindeling is het verdelen van onderdelen over één of meer platen. Plaatplan doet dat visueel: je ziet elk paneel op de plaat, welke platen nieuw zijn en welke reststukken worden gebruikt.",
    "ctaLabel": "Zaagindeling berekenen",
    "sections": [
      {
        "h2": "Van zaaglijst naar indeling",
        "paragraphs": [
          "Begin met een lijst van panelen (lengte × breedte × aantal). Plaatplan maakt er een indeling van op standaardplaten, zonder handmatig puzzelen op papier."
        ]
      },
      {
        "h2": "Meerdere diktes en projecten",
        "paragraphs": [
          "Panelen met verschillende dikte komen op aparte platen. Meerdere projecten in één sessie? Elk deelproject krijgt een kleur in het zaagschema."
        ]
      }
    ]
  }
};
